import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "mb_pwa_dismissed_v1";

export default function PWAInstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(DISMISS_KEY)) return;
    // iOS doesn't fire beforeinstallprompt — show iOS-specific hint
    const ua = window.navigator.userAgent;
    const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;
    if (iOS) {
      setIsIOS(true);
      setShow(true);
      return;
    }
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setShow(false);
    setDeferred(null);
  };

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-[9998] bg-blue-950 text-white rounded-2xl shadow-2xl border border-blue-800 p-4 flex items-start gap-3" data-testid="pwa-install-prompt">
      <div className="shrink-0 w-10 h-10 rounded-xl bg-amber-400 text-amber-950 flex items-center justify-center">
        <Download size={20}/>
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-display font-bold text-sm leading-tight">Instale o Morar Bem no seu celular</p>
        {isIOS ? (
          <p className="text-xs text-blue-100/80 mt-1">Toque em <strong>Compartilhar</strong> ↑ e depois <strong>"Adicionar à Tela de Início"</strong>.</p>
        ) : (
          <p className="text-xs text-blue-100/80 mt-1">Acesso rápido, tela cheia, funciona como app nativo.</p>
        )}
        {!isIOS && (
          <button onClick={install} className="mt-2 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-amber-400 text-amber-950 text-xs font-bold hover:bg-amber-300" data-testid="pwa-install-btn">
            <Download size={12}/> Instalar agora
          </button>
        )}
      </div>
      <button onClick={dismiss} className="text-blue-200/70 hover:text-white" aria-label="Fechar" data-testid="pwa-dismiss-btn">
        <X size={16}/>
      </button>
    </div>
  );
}
